import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_TherapeuticBehavioralOnsiteServices = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_TherapeuticBehavioralOnsiteServices' className='file-pdf-document'>
            <div className='file-template'>
                <h3>Therapeutic Behavioral Onsite Services (TBOS)</h3>
                <h4>Eligibility Checklist and Certification/Recertification</h4>

                <span className='small'>(To be completed for all clients at intake and every 3 months
                    thereafter for clients reciving TBOS services)
                </span>

                <p className='w-750'>
                    Please answer the following questions to determine if the recipient is eligible for TBOS Services.
                    If the recipient is deemed eligible, ensure the services are prescribed in the Treatment Plan.
                    Continued eligibility must be assessed at least once every six months.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is the client under 21 years of age?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbClientAgeY' name='cbClientAgeY' className='add-only' value='Yes' />
                        </td>
                        <td className='w-720'>Yes-If the client is under 21 years of age please move to the next question.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbClientAgeN' name='cbClientAgeN' className='add-only' value='No' />
                        </td>
                        <td className='w-720'>No-The client is not eligible for TBOS Services. There is no need to continue to the next
                            question.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please review eligibility criteria for Individual and Family Therapy to determine
                            if client meets criteria.
                        </td>


                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is the recipient at risk of out of home placement?</span>
                            <span className='small'>(For example:incarceration,Baker Act, inpatient placement,
                                therapeutic-foster home, respite services, independent living facilities, or homelessness)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbRecipientPlaceY' name='cbRecipientPlaceY' className='add-only' value='Yes' />
                        </td>
                        <td className='w-720'>Yes-If the recipient is at risk of out of home placement, please move on to the next question.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbRecipientPlaceN' name='cbRecipientPlaceN' className='add-only' value='No' />
                        </td>
                        <td className='w-720'>No-The recipient is not eligible for TBOS Services. There is no need to continue to the next question.
                        </td>
                    </tr>
                    <tr>

                        <td className='w-750'>Please review eligibility criteria for Individual and Family Therapy to determine if
                            recipient meets criteria.
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does the recipient have an ICD-10 diagnosis in the following range:
                                290-298.9,300-301.9,302.7,303-312.4,312.81-314.9,315.3,315.31,315.5,315.8-315.9?
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbRecipientDiagY' name='cbRecipientDiagY' className='add-only' value='Yes' />
                        </td>
                        <td className='w-720'>Yes-Provide recipient's diagnosis below,then move on to the next question.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Recipient's Diagnosis:</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtDiagnosisR' name='txtDiagnosisR' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbRecipientDiagN' name='cbRecipientDiagN' className='add-only' value='No' />
                        </td>
                        <td className='w-720'>No-The recipient is not eligible for TBOS Services.There is no need to continue to the next question.
                        </td>
                    </tr>
                    <tr>

                        <td className='w-750'>Please review eligibility criteria for Individual and Family Therapy to determine if
                            recipient meets criteria.
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Has the recipient scored a 60 or below on the CGAS within the last month;or has a diagnosis
                                of 295-298.9?
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbDiagnosisCritY' name='cbDiagnosisCritY' className='add-only' value='Yes' />
                        </td>
                        <td className='w-720'>Yes-Provide recipient's CGAS score below or indicate recipient meets diagnostic criteria,
                            then move pn the next question.
                        </td>
                    </tr>
                </table> 
                <p className='w-750'>
                            Recipient's CGAS Score:
                        <input type='text' id='txtRecipientScore1' name='txtRecipientScore1' className='add-only w-150 custom-add-only' /> or,
                            <input type='text' id='txtRecipientScore2' name='txtRecipientScore2' className='add-only w-150 custom-add-only' />
                            Meets diagnostic criteria
                </p>
                <table>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbDiagnosisCritN' name='cbDiagnosisCritN' className='add-only' value='No' />
                        </td>
                        <td className='w-720'>No-The recipient is not eligible for TBOS Services. There is no need to continue to the next question.
                        </td>
                    </tr>
                    <tr>

                        <td className='w-750'>Please review eligibility criteria for Individual and Family Therapy to determine if
                            recipient meets criteria.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Please select the box below that matches the recipient's age grouping</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recipient's Age:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtRecipAge' name='txtRecipAge' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Two Years and Under
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please indicate if the recipient meets any of the following criteria.
                            The recipient must meet atleast one of the following criteria to be eligible for TBOS Services:
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbSymDevelop' name='cbSymDevelop' className='add-only' value='Symptoms' />
                        </td>
                        <td className='w-720'>Exhibits symptoms to a emotional or behavioral nature that are atypical for the recipient's age and
                            development that interferes with social and relationship development.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbFailureThrive' name='cbFailureThrive' className='add-only' value='Failure' />
                        </td>
                        <td className='w-720'>Exhibits failure to thrive (due to emotional or psychosocial causes, not solely medical issues).
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Ages Two to Five years
                            </span>
                        </td>
                    </tr>
                    <tr className='w-750'>
                        <td  className='w-750'>Please indicate if the recipient meets any of the following criteria.
                            The recipient must meet atleast both of the following criteria to be eligible for TBOS Services:
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbSymRecip' name='cbSymRecip' className='add-only' value='Symptom Recipient' />
                        </td>
                        <td className='w-720'>Exhibits symptoms of an emotional or behavioral nature that are atypical for the recipient's age and
                            development.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbScoreSpecific' name='cbScoreSpecific' className='add-only' value='Yes' />
                        </td>
                        <td className='w-720'>Scores in at least the moderate impairment range on a behavior and functional rating scale developed
                            for the specific age group (CFARS or FARS)
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Ages Six to Seventeen Years
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please indicate if the recipient meets any of the following criteria.
                            The recipient must meet atleast one of the following criteria to be eligible for TBOS Services:
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbEmotional' name='cbEmotional' className='add-only' value='Emotional' />
                        </td>
                        <td className='w-720'>Has an emotional disturbance.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbSerious' name='cbSerious' className='add-only' value='Yes' />
                        </td>
                        <td className='w-720'>Has an serious emotional disturbance.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbUseDiscorder' name='cbUseDiscorder' className='add-only' value='Yes' />
                        </td>
                        <td className='w-720'>Has a substance use disorder.
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Ages Eighteen to Twenty Years
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please indicate if the recipient meets any of the following criteria.
                            The recipient must meet atleast one of the following criteria to be eligible for TBOS Services:
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-30'>
                            <input type='checkbox' id='cbEmotionalDis' name='cbEmotionalDis' className='add-only' value='Emotional' />
                        </td>
                        <td className='w-720'>Meet the criteria for an emotional disturbance or a serious emotional disturbance.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>This document serves as an eligibility checklist and certification that the client was
                        screened and determined to meet that client eligibility criteria to remove TBOS.
                    </strong>
                </p>


            </div>
        </form>

    )
}











